{
  "receive.heading": "Réception",
  "receive.description": "Cette page affiche l'état, le cycle et le nombre de conteneurs et de packages dans le processus de réception",
  "receive.filter.title": "Options",
  "receive.filter.cycle": "Cycle",
  "receive.current_planned": "Actuel Prévu",
  "receive.current_actual": "Courant Arrivé Réel",
  "receive.other": "Autre/Non planifié Arrivé Réel",
  "CPT.": "CPT",
  "CPT.cpt": "CPT",
  "CPT.induct_by": "Introniser par",
  "CPT.stow_by": "Rangement par",
  "receive.overall_status": "État général",
  "receive.packages": "Colis",
  "receive.predicted_dispatch": "Prédiction manifestée",
  "receive.total_manifested": "Sur manifeste au total",
  "receive.container_planned_volume": "Volume planifié du conteneur",
  "receive.current_cycle_planned": "Cycle actuel planifié",
  "receive.current_cycle_actual": "Cycle actuel actualisé",
  "receive.other_cycles": "Autres cycles",
  "package.cpt": "CPT",
  "receive.total": "Total",
  "receive.current_status": "Statut actuel",
  "receive.manifested": "En attente de départ du flux en amont",
  "receive.in_transit": "En cours de transit du flux en amont",
  "receive.arrived": "En attente de démarrage",
  "receive.marked_for_reprocess": "En attente de redémarrage",
  "receive.inducted": "Démarré",
  "receive.stow_buffered": "Stow Buffered",
  "receive.stowed": "Stocké",
  "receive.sidelined": "Mis de côté",
  "receive.group_by": "Groupe par",
  "linehaul.linehauls": "Acheminements",
  "linehaul.status": "Statut",
  "linehaul.arrival": "Arrivée",
  "linehaul.details": "Détails",
  "linehaul.vrid": "VRID",
  "linehaul.origin": "Origine",
  "linehaul.location": "Lieu",
  "linehaul.planned": "Planifié",
  "linehaul.actual": "Actualisé",
  "linehaul.volume": "Volume",
  "linehaul.FMC": "FMC",
  "linehaul.unloadSequence": "Séquence de déchargement",
  "linehaul.inyard": "En parc",
  "linehaul.arrived": "Arrivé",
  "linehaul.incoming": "Entrant",
  "linehaul_detail.receive": "Réception",
  "linehaul_detail.linehaul_details": "Détails de l’acheminement",
  "linehaul_detail.linehaul": "Acheminement ",
  "linehaul_detail.from": "De",
  "linehaul_detail.departed": "Parti",
  "linehaul_detail.arrived": "Arrivé",
  "linehaul_detail.options": "Options",
  "linehaul_detail.id": "ID",
  "linehaul_detail.type": "Type",
  "linehaul_detail.pending_induct": "En attente de démarrage ",
  "linehaul_detail.total": "Total ",
  "linehaul_filter.packagesize": "Taille du colis",
  "linehaul_filter.ead": "Station EAD",
  "linehaul_filter.cycle": "Cycle",
  "linehaul_filter.cluster": "Cluster",
  "linehaul_filter.otherattributes": "Autres attributs",
  "linehaul_filter.clear_all": "Tout effacer",
  "induct.heading": "Démarrage",
  "induct.description": "Cette page affiche l'état, le cycle et le nombre de conteneurs et de packages dans le processus d'induction",
  "induct.induct": "Démarrage",
  "induct.induct_area": "Zones de démarrage",
  "induct.active_associate": "Associés actifs",
  "induct.induct_rate": "Débit de démarrage",
  "induct.total_inducted": "Démarrés au total",
  "induct.container": "Conteneur",
  "induct.container_id": "ID",
  "induct.type": "Type",
  "induct.pending_induct": "En attente de démarrage ",
  "induct.total": " Total",
  "induct.aslInductArea": "Aire d'Induct ASL",
  "induct.max_induct_rate": "Taux Max d'Induct",
  "induct.station_percentage": "% de la station",
  "induct.successful_percentage": "% de scans réussis",
  "induct.kickout": "Kickout",
  "induct.noread": "NoRead",
  "induct.timeout": "Timeout",
  "induct.failed_verification": "Failed Verification",
  "induct.sidelined": "Sidelined",
  "induct.cycle": "Cycle",
  "associate.heading": "Démarrage des associés",
  "associate.description": "Cette page affiche les données de performance des associés d'induction et l'emplacement de travail actuel",
  "associate.option": "Options",
  "associate.active": "Actif",
  "associate.associates": "Associés",
  "associate.associate": "Associé",
  "associate.pph": "PPH",
  "associate.hours": "Heures",
  "associate.total_packages": "Colis au total",
  "associate.location": "Lieu",
  "associate.inactive_period": "Période d’inactivité",
  "package.package_summary": "Synthèse du colis",
  "package.tracking_id": "ID de suivi",
  "package.last_scan_date_time": "Dernier scan",
  "package.minutes_in_state": "Minutes dans l’état",
  "package.package_state": "État",
  "package.package_reason": "Raison",
  "package.location": "Lieu",
  "package.cycle": "Cycle",
  "package.sort_zone": "Zone de tri",
  "package.cluster": "Cluster",
  "package.EAD": "Station EAD",
  "package.size": "Taille",
  "package.station_code": "Destination",
  "package.package_list": "Liste des colis",
  "induct.error": "Une erreur s'est produite",
  "tooltip.max_induct_rate": "Taux d'induct maximal attendu pour la machine ASL",
  "tooltip.induct_rate": "Nombre de colis inductés en moyenne par heure avec la machine ASL",
  "tooltip.total_inducted": "Total number of packages inducted in the current shift.",
  "tooltip.station_percentage": "Pourcentage du volume total de la station inducté par la machine ASL",
  "tooltip.successful_percentage": "Pourcentage de colis scannés avec succès par la machine ASL",
  "tooltip.kickout": "Nombre de colis qui ont été rejeté durant l'Induct ASL",
  "tooltip.noread": "Nombre de colis ASL traités où un code barre valide n'a pas été lu par la caméra",
  "tooltip.timeout": "Nombre de scans de colis ASL traités ayant subit un problème de latence du système",
  "tooltip.stowbuffered_cycle": "Les expéditions qui se trouvent actuellement dans cet état de colis et qui ont été mises en mémoire tampon avec succès au cours de ce cycle",
  "tooltip.failed_verification": "Nombre de colis ASL traités qui n'ont pas été vérifiés par la caméra de sortie",
  "tooltip.non_conveyable_description": "NC: Packages that exceed 42'' in a single dimension. \n FCLM might have different dimension criteria for NC",
  "generic.error": "Une erreur est survenue",
  "generic.close": "Fermer",
  "generic.enabled" : "Activée",
  "generic.disabled" : "désactivé",

  "header.induct_management": "Gestion des intrants",

  "induct_management.induct_setup": "Mise en place de l'installation",
  "induct_management.select_cycle": "Sélectionnez le cycle",
  "induct_management.current_sort_cycle": "Cycle de tri actuel",
  "induct_management.current_cycle_state": "État actuel du cycle",
  "induct_management.current_force_induct_status": "Statut actuel d'intrusion de force",
  "induct_management.enable_force_induct": "Activer l'induction de force",
  "induct_management.sort_cycle": "Cycle de tri",
  "induct_management.force_induct_sort_cycle": "Forcer l'induction de tous les packages reçus dans le cycle de tri en cours",
  "induct_management.start_sort_cycle": "Démarrer l'induction",
  "induct_management.container_plan_failure" : "Une erreur s'est produite lors de l'extraction du plan de conteneur. Veuillez réessayer plus tard",
  "induct_management.mapped_cycles_failure" : "Une erreur est survenue lors de la récupération des cycles actifs. S'il vous plaît essayez à nouveau Laterr",
  "induct_management.set_node_operational_failure" : "Une erreur s'est produite lors de l'enregistrement du cycle d'initiation. Veuillez réessayer plus tard",
  "induct_management.get_node_operational_failure" : "Une erreur s'est produite lors de l'obtention des informations sur le cycle de tri en cours. Veuillez réessayer plus tard",
  "induct_management.non_mco_station" : "Cette page n'est pas encore activée pour votre station. Si votre station prend en charge les opérations à cycles multiples, restez à l'écoute pour plus de mises à jour :-)",
  "induct_management.bad_request" : "Veuillez sélectionner le cycle correct dans la liste déroulante",
  "induct_management.set_node_induct_process_details_success" : "Le cycle d'introduction a été lancé avec succès",
  "induct_management.no_active_container_plans_available" : "Aucun plan de conteneur actif n'est configuré pour cette station. Veuillez réessayer ultérieurement.",
  "induct_management.pick_started_for_the_current_cycle" : "Pick a été lancé pour le cycle en cours, donc l'induct est bloqué",
  "induct_management.start_induct" : ". Veuillez changer pour corriger le cycle et démarrer le processus d'induction.",
  "common.data_last_updated": "Dernière mise à jour des données",
  "inductmanagement.heading": "Gestion du cycle d'induction",
  "inductmanagement.description": "Cette page vous permet de modifier les paramètres du cycle d'induction",
  "inductmanagement.manage_cycle": "Gérer les cycles",
  "inductmanagement.force_induct": "Balayage d'induction de force",
  "inductmanagement.active_until": "Actif jusqu'au",
  "inductmanagement.noCycles": "Aucun cycle disponible",
  "inductmanagement.disableCycle": "Désactiver le cycle",
  "inductmanagement.enableCycle": "Activer le cycle",
  "inductmanagement.enterCycle": "Entrer le cycle...",
  "inductmanagement.enterStationCode": "Entrez le code de la station...",
  "inductmanagement.noStations": "Aucune station disponible",
  "inductmanagement.selectStatus": "Sélectionnez le statut...",
  "inductmanagement.enableForceInduct": "Activer l'induction de force",
  "inductmanagement.disableForceInduct": "Désactiver l'induction de force",
  "inductmanagement.activateSortToRouteError": "Impossible d'activer un autre cycle de type SORT_TO_ROUTE. {cycle} est déjà actif.",
  "inductmanagement.activateCycleError": "Une erreur s'est produite lors de l'activation du cycle : {cycle}",
  "inductmanagement.deactivateCycleError": "Une erreur s'est produite lors de la désactivation du cycle : {cycle}",
  "inductmanagement.unselectedWarning": "Sélectionnez un nœud et effectuez un cycle avant de cliquer sur Activer",
  "inductmanagement.setForceError": "Une erreur s'est produite lors de la mise à jour de l'induction de la force pour le cycle : {CycleName}",
  "inductmanagement.submit": "Soumettre",
  "inductconfig.noActiveLanes": "Toutes les voies sont soit inactives soit de rétention, aucune voie restante pour les palettes ou chariots.",
  "inductconfig.noCartLanes": "Toutes les voies sont soit inactives, de rétention ou de palettes. Aucune voie restante pour les chariots.",
  "inductconfig.noBeltsConfigured": "Aucun convoyeur d'induction configuré. Veuillez ajouter au moins un convoyeur.",
  "inductconfig.holdLaneWarning": "Aucune voie de rétention configurée. Les conteneurs ne peuvent pas être retenus pendant ce cycle. Voulez-vous continuer ?",
  "inductconfig.singleBeltWarning": "Un seul convoyeur actif configuré. Si ce convoyeur tombe en panne, aucun colis ne peut être induit. Voulez-vous continuer ?",
  "inductconfig.inactiveHoldOverlap": "La/les voie(s) inactive(s) {lanes} ne peuvent pas être également dans les voies de rétention.",
  "inductconfig.inactivePalletOverlap": "La/les voie(s) inactive(s) {lanes} ne peuvent pas être également dans les voies de palettes.",
  "inductconfig.palletLanes": "Voies de Palettes",
  "inductconfig.priorityLaneCount": "Nombre de Voies Prioritaires",
  "inductconfig.priorityLaneCountHint": "Entrez le nombre de voies prioritaires (ex. 25)",
  "inductconfig.beltNoContainerTypes": "Un ou plusieurs convoyeurs n'ont aucun type de conteneur sélectionné. Sélectionnez au moins un type de conteneur pour chaque convoyeur.",
  "inductconfig.beltNoCubeTypes": "Un ou plusieurs convoyeurs n'ont aucun type de cube sélectionné. Sélectionnez au moins un type de cube pour chaque convoyeur.",
  "inductconfig.noActiveBelts": "Aucun convoyeur d'induction actif configuré. Au moins un convoyeur doit être actif pour traiter les colis.",
  "inductconfig.containerTypeNotCovered": "Un ou plusieurs types de conteneur ne sont attribués à aucun convoyeur actif. Tous les types de conteneur doivent être couverts par au moins un convoyeur actif.",
  "inductconfig.cubeTypeNotCovered": "Un ou plusieurs types de cube ne sont attribués à aucun convoyeur actif. Tous les types de cube doivent être couverts par au moins un convoyeur actif.",
  "inductconfig.invalidLaneEntered": "Voie invalide saisie. Veuillez entrer un identifiant de voie valide.",
  "inductconfig.selectCycleBeforeUpload": "Veuillez sélectionner un cycle avant de lancer le téléchargement.",
  "inductconfig.invalidCycleInCsv": "Cycle invalide ou manquant dans le CSV. Veuillez entrer un cycle valide."
}
